import { render, staticRenderFns } from "./OrganisationEdit.vue?vue&type=template&id=0abab234&"
import script from "./OrganisationEdit.vue?vue&type=script&lang=ts&"
export * from "./OrganisationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abab234')) {
      api.createRecord('0abab234', component.options)
    } else {
      api.reload('0abab234', component.options)
    }
    module.hot.accept("./OrganisationEdit.vue?vue&type=template&id=0abab234&", function () {
      api.rerender('0abab234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationEdit.vue"
export default component.exports